import DOMPurify from "dompurify";

export default function(html) {
  const regex = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|xxx|memory):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i;

  return DOMPurify.sanitize(
    html,
    {
      ADD_ATTR: ["target"],
      USE_PROFILES: { html: true },
      ALLOWED_URI_REGEXP: regex
    }
  );
}
